import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const CreateTermMutation = graphql.persisted(
  "CreateTerm",
  graphql(`
    mutation CreateTerm($input: CreateTermInput!) {
      createTerm(input: $input) {
        term {
          id
          name
          slug
          position
          startsOn
          endsOn
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { CreateTermMutation };

export function useCreateTerm() {
  return useMutation(CreateTermMutation);
}
